import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "graphql-for-grandjs"
    }}>{`GraphQl for Grandjs`}</h1>
    <p>{`Grandjs now supports graphql using apollo server for building performant APis using graphql with the help of grandjs speed`}</p>
    <h2 {...{
      "id": "installing"
    }}>{`Installing`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-cmd"
      }}>{`npm i apollo-grand-server
`}</code></pre>
    <h3 {...{
      "id": "dependencies"
    }}>{`Dependencies`}</h3>
    <p>{`You need to install the following dependencies to be able to use `}<inlineCode parentName="p">{`apollo-grand-server`}</inlineCode></p>
    <ul>
      <li parentName="ul">{`type-graphql`}</li>
      <li parentName="ul">{`grand-connectors`}</li>
      <li parentName="ul">{`grandjs`}</li>
      <li parentName="ul">{`reflect-metadata`}</li>
    </ul>
    <h3 {...{
      "id": "using"
    }}>{`Using`}</h3>
    <p>{`At first import grandjs needed Classes and utilities`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { Server, Router } from 'grandjs';
`}</code></pre>
    <p>{`to start use apollo server you need to import it from `}<inlineCode parentName="p">{`apollo-grand-server`}</inlineCode>{` library as the following:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { ApolloServer } from 'apollo-grand-server';
`}</code></pre>
    <p>{`Setting Up Grandjs Server`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`Server.setConfig({
  port: 3000,
  nativeParsing: false,
  cors : {
    origin: '*',
    methods: 'GET,HEAD,PUT,PATCH,POST,DELETE',
    preflightContinue: false,
    optionsSuccessStatus: 204
},
})

Server.use(<any>urlencoded({extended: false}));
Server.use(<any>json());
`}</code></pre>
    <p>{`Then initiate grandjs server`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`Server.initServer(() => {
  console.log(\`server now is running on 3000\`)
})
`}</code></pre>
    <p>{`Then instantiate `}<inlineCode parentName="p">{`ApolloServer`}</inlineCode>{` class as the following:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`const server = new ApolloServer({schema});
`}</code></pre>
    <p>{`Now you need to use `}<inlineCode parentName="p">{`applyMiddleWare`}</inlineCode>{` method from `}<inlineCode parentName="p">{`apollo grandjs Server`}</inlineCode>{` as the following:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`server.applyMiddleware({Router});
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      